import React, { useState } from 'react';
import config from '../../../utils/config';
import { useAuth } from '../../../wms/context/wms-context';

export default function ControlHeader() {
    const ORIGIN = config.origin;
    const { currentUser } = useAuth();

    const [releaseNumber, setReleaseNumber] = useState('');

    const handleGeneratePickingTags = (e) => {
        e.preventDefault();

        const formattedReleaseNumber = releaseNumber.toLowerCase().includes('rls-') ? releaseNumber : `RLS-${releaseNumber}`;

        let dataToSend = {
            releaseNumber: formattedReleaseNumber,
            authentication: {
                userId: currentUser.authentication.userId,
                userEmail: currentUser.authentication.userEmail,
                userCompany: currentUser.authentication.userCompany || localStorage.getItem('company'),
            },
        };

        fetch(`${ORIGIN}/wms/picking/get-picking-tags`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(dataToSend),
        })
            .then((res) => res.blob())
            .then((blob) => {
                // open in a new tab
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.target = '_blank';
                //name of the file
                a.name = 'order.pdf';
                a.click();
            })
            .catch((err) => console.log(err));
    };

    return (
        <>
            <div className='p-4'>
                <div className='flex justify-between'>
                    <form className='flex flex-col'>
                        <label className='text-gray-700'>
                            Enter or Scan Release Number#<span className='text-gray-400'>(RLS-275547)</span>
                        </label>
                        <div className='flex flex-col items-center space-x-4 md:flex-row'>
                            <input
                                type='text'
                                onChange={(e) => {
                                    setReleaseNumber(e.target.value);
                                }}
                                autoFocus
                                placeholder='Type in or Scan Release Number'
                                className='p-2 w-72 rounded border disabled:opacity-50'
                            />
                            <button
                                type='submit'
                                onClick={(e) => {
                                    handleGeneratePickingTags(e);
                                }}
                                className='p-2 w-48 text-white rounded border cursor-pointer bg-blue-primary disabled:opacity-50'
                            >
                                Generate Picking Tags
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
}
